<template lang="html">
  <div class="diak_tanfolyam-component">
    <h2 class="text-center">Tanfolyamok</h2>
  <v-container>
    <v-progress-linear
          v-if="loading"
          indeterminate
          color="red"
    ></v-progress-linear>
    <v-container>
      <v-data-table
      v-if="student_course_details != ''"
      :headers="student_course_headers"
      :items="student_course_details"
      :items-per-page="5"
      class="elevation-1"
      show-expand
      hide-default-footer
      hide-default-header
      disable-sort
    >
      <template
        v-slot:header="{ props: { headers, mobile } }"
      >
        <thead v-if="!mobile">
          <tr>
            <th></th>
            <th class="text-left">Tanfolyam száma</th>
            <th class="text-left">Tanfolyam kezdete</th>
            <th class="text-left">Tanfolyam vége</th>
            <th class="text-left">Helyszín</th>
            <th class="text-left">Státusz</th>
          </tr>
        </thead>
      </template>

      <template v-slot:item.data-table-expand="{ item }">
      <v-menu>
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          v-on="on"
          v-if="student_course_details != ''"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="selected_course = null, courseDetails(item.course_id)">
          <v-list-item-title>
            Tanfolyam részletei
            <v-icon>date_range</v-icon>
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="item.soap_course_type_code !='EÜ'" @click="downloadContract(item.course_id)">
          <v-list-item-title>
            Tanulmányi szerződés
            <v-icon>assignment</v-icon>
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click="del_course_dialog = true, course_del_id = item.course_id, courses_data_del_id = item.course_data_id, course_student_del_id = item.course_student_id">
          <v-list-item-title class="red--text">
            Leiratkozás a tanfolyamról
            <v-icon color="red">delete</v-icon>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
      </template>

    </v-data-table>
    </v-container>

    <v-dialog
      v-model="course_details_dialog"
      width="900"
      scrollable
    >
      <v-card>

        <v-toolbar dark color="grey lighten-2">
        <v-toolbar-title class="black--text">Tanfolyam részletei</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="course_details_dialog = false">
            <v-icon color="black">mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-data-table
            :headers="course_lessons_header"
            :items="course_lessons"
            :items-per-page="20"
            hide-default-footer
            hide-default-header
          >
          <template
            v-slot:header="{ props: { headers, mobile } }"
          >
            <thead v-if="!mobile">
              <tr>
                <th class="text-left">Sorszám</th>
                <th class="text-left">Tantárgy</th>
                <th class="text-left">Kezdés</th>
                <th class="text-left">Befejezés</th>
                <th class="text-left">Helyszín</th>
              </tr>
            </thead>
          </template>
          </v-data-table>
        </v-card-text>

      </v-card>
    </v-dialog>

    <v-row>
    <v-col class="text-center" cols="12">
      <p v-if="contracts == '' && !loading">Ahhoz, hogy tanfolyamra tudjon jelentkezni, legalább egy tanulmányi szerződéssel kell rendelkeznie.</p>
      <v-btn
        v-if="contracts == ''"
        rounded
        color="primary"
        to="/kategoriak"
      >
      Szerződések
      </v-btn>
      <p v-if="student_course_details == '' && contracts != '' && !loading">Még nem jelentkezett tanfolyamra. Kérjük válasszon egyet!</p>
    <v-btn
      v-if="contracts != ''"
      rounded
      color="primary"
      @click="add_course_dialog=true, selected_course=null, searchCourses()"
    >
    Tanfolyamra jelentkezés
    <v-icon dark>mdi-plus</v-icon>
    </v-btn>
    </v-col>
  </v-row>
  <template>
  <v-row justify="center">
    <v-dialog v-model="add_course_dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="green">
        <v-toolbar-title>Tanfolyam választása</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="add_course_dialog = false, tanfolyam_search_text = null">
            <v-icon large dark>cancel</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <br>
        <v-card-text>
          <v-container>
          <v-row>
            <v-col cols="12">
            <v-select
              v-model="tanfolyam_search_text"
              :items="offices"
              item-text="full_address"
              item-value="training_place_id"
              label="Oktatási helyszín választása"
              outlined
            ></v-select>
            </v-col>
          </v-row>
          <p class="text-center" v-if="courses_to_add == ''">Ehhez a kategóriához jelenleg nincs meghirdetve tanfolyam! <br> Kérjük tanfolyam igényét <a @click="message_dialog = true">jelezze ügyfélszolgálatunk felé!</a></p>
            <v-data-table
            v-if="courses_to_add != ''"
            :headers="add_course_header"
            :items="courses_to_add"
            item-key="course_id"
            show-expand
            hide-default-header
            >

          <template
            v-slot:header="{ props: { headers, mobile } }"
          >
            <thead v-if="!mobile">
              <tr>
                <th></th>
                <th class="text-left">Tanfolyam száma</th>
                <th class="text-left">Tanfolyam kezdete</th>
                <th class="text-left">Tanfolyam vége</th>
                <th class="text-left">Tanfolyam típus</th>
                <th class="text-left">Helyszín</th>
              </tr>
            </thead>
          </template>

          <template v-slot:item.data-table-expand="{ item }">
            <v-btn outlined rounded color="primary" @click="selected_course = item.course_id, selected_course_school_id = item.driving_school_id, selected_course_type = item.nkh_course_type_id, searchCourseLessons(item.course_id)">
              Részletek
            </v-btn>
          </template>

          </v-data-table>
          </v-container>
        </v-card-text>
      </v-card>

    <v-dialog
      v-model="course_details"
      width="900"
      scrollable
    >

      <v-card>

        <v-toolbar dark color="grey lighten-2">
        <v-toolbar-title class="black--text">Tanfolyam részletei</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="course_details = false">
            <v-icon color="black">mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-data-table
            :headers="course_lessons_header"
            :items="course_lessons"
            :items-per-page="20"
            hide-default-footer
            hide-default-header
          >
          <template
            v-slot:header="{ props: { headers, mobile } }"
          >
            <thead v-if="!mobile">
              <tr>
                <th class="text-left">Sorszám</th>
                <th class="text-left">Tantárgy</th>
                <th class="text-left">Kezdés</th>
                <th class="text-left">Befejezés</th>
                <th class="text-left">Helyszín</th>
              </tr>
            </thead>
          </template>
        </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-col cols="12" class="d-flex justify-center">
          <v-btn
            color="red"
            outlined
            rounded
            @click="preg_dialog = true"
          >
            Jelentkezés a tanfolyamra
          </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    </v-dialog>
  </v-row>
</template>
  </v-container>

  <div v-if="jellap_show">
  <DiakJellap></DiakJellap>
  </div>
  <v-snackbar v-model="response_snackbar" bottom :color="snackbar_color">
    {{ response_text }}
    {{nevsor_response_text}}
    <v-btn :color="snackbar_close" text @click="response_snackbar = false">
      Bezár
    </v-btn>
  </v-snackbar>

  <v-dialog v-model="del_course_dialog" persistent max-width="290">
    <v-card>
      <v-card-text><p class="pt-4">Biztosan leiratkozik a tanfolyamról?</p></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" outlined @click="del_course_dialog = false">Nem</v-btn>
        <v-btn color="green" outlined @click="delStudentCourse(), del_course_dialog = false">Igen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="preg_dialog" persistent max-width="290">
    <v-card>
      <v-container><p class="pt-4"><b>Biztosan regisztrál a tanfolyamra?</b></p>
                  <v-select
                    v-model="payment_method"
                    :items="payment_methods"
                    label="Fizetési mód"
                    outlined
                    :rules="[rules.required]"
                  ></v-select>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" outlined @click="preg_dialog = false">Nem</v-btn>
        <v-btn color="green" outlined @click="preg_dialog = false, course_details = false, addStudentCourse()" :disabled="!payment_method">Igen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="loading_dialog" persistent max-width="400">
    <v-card>
      <v-card-text class="text-center">
        <h2 v-if="preg_preloader" class="pt-4">Regisztráció folyamatban!</h2>
        <br>
        <v-progress-circular
          :size="50"
          indeterminate
          color="red"
          v-if="preg_preloader"
        ></v-progress-circular>
        <h2 v-if="!preg_preloader">{{response_text}}</h2>
        <v-row class="justify-center">
        <v-col cols="12" md="8">
        <v-btn
          v-if="contract_course_id && selected_course_type != 64"
          color="primary"
          rounded
          @click="downloadContract()"
          :loading="preloader"
        >
        Szerződés letöltése
        <v-icon right dark>cloud_download</v-icon>
        </v-btn>
        </v-col>
        <v-col cols="12" md="8">
          <v-btn
            v-if="invoice_id && !public_url"
            color="primary"
            rounded
            @click="downloadInvoice()"
            :loading="preloader"
          >
          Díjbekérő letöltése
          <v-icon right dark>attach_money</v-icon>
          </v-btn>
          <v-btn
            class="white--text"
            v-if="invoice_id && public_url"
            color="primary"
            rounded
            :href="public_url"
            target="_blank"
          >
          Díjbekérő befizetése
          <v-icon right dark>attach_money</v-icon>
          </v-btn>
        </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="loading_dialog = false, contract_course_id = null, invoice_id = null">Bezár</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  </div>
</template>

<script>

import {
  mapFields
} from 'vuex-map-fields';
import { EventBus } from '../event-bus';

  export default {
    data () {
      return {
        student_course_details: '',
        loading: false,
        school_id: '',
        jellap_show: false,
        add_course_dialog: false,
        add_course_header: [
          { text: 'Tanfolyam száma', value: 'course_number'},
          { text: 'Kezdés', value: 'course_start' },
          { text: 'Befejezés', value: 'course_end' },
          { text: 'Tanfolyam típus', value: 'course_type' },
          { text: 'Helyszín', value: 'place_name' },
          { text: '' }
        ],
        student_course_headers: [
          { text: 'Tanfolyam száma', value: 'course_number'},
          { text: 'Kezdés', value: 'start_date' },
          { text: 'Befejezés', value: 'end_date' },
          { text: 'Helyszín', value: 'place_name' },
          { text: 'Státusz',  value: 'status' },
        ],
        course_lessons_header: [
          { text: 'Sorszám', value: 'sorszam'},
          { text: 'Tantárgy', value: 'nkh_subject_name'},
          { text: 'Kezdés', value: 'start_date' },
          { text: 'Befejezés', value: 'end_date' },
          { text: 'Helyszín', value: 'place_name' },
        ],
        courses_to_add: '',
        tanfolyam_search_text: '',
        selected_course: '',
        selected_course_school_id: '',
        course_add_button: false,
        response_text: '',
        nevsor_response_text: '',
        response_snackbar: false,
        snackbar_color: '',
        snackbar_close: 'pink',
        course_del_id: '',
        courses_data_del_id: '',
        course_student_del_id: '',
        kepzesi_course_id: '',
        del_course_dialog: false,
        roster_status: '',
        preg_course_data_id: '',
        preg_course_student_id: '',
        preg_driving_school_id: '',
        preg_dialog: false,
        course_start: '',
        course_end: '',
        offices: [],
        course_details: false,
        course_lessons: [],
        course_details_dialog: false,
        loading_dialog: false,
        prereg_result: '',
        invoice_id: '',
        invoice_number: '',
        contract_course_id: '',
        iv_driving_school: '',
        preg_preloader: false,
        soap_course_type_code: '',
        selected_course_type: '',
        payment_methods: [
          { text: 'Bankkártya (online)', value: 17 },
          { text: 'Átutalás', value: 2 },
        ],
        payment_method: '',
        rules: {
            required: value => !!value || 'Kötelező mező!',
        },
      }
    },
    methods: {
      getOffices: async function() {
        await this.gettoken()
        this.$http.post('/tanfolyam/csigaver_office', {
          token: this.token
        }).then((response) => {
          this.offices = response.data
        }, (error) => {
          console.log(error.data);
        })
      },
      getCourseDetails: async function() {
        this.loading = true
        this.jellap_show = false
        this.course_student_id = null
        await this.gettoken()
        this.$http.post('/tanfolyam/tanfolyam_adatok', {
          token: this.token,
          contract_id: this.contract_id,
          //customer_id: this.customer_id,
        }).then((response) => {
          this.preloader = false
          this.loading = false
          this.student_course_details = response.data
          this.school_id = response.data[0]['driving_school_id']
          this.course_student_id = response.data[0]['course_student_id']
          this.soap_course_type_code = response.data[0]['soap_course_type_code']
        }, (error) => {
          console.log(error.data);
        })
      },
      searchCourses: async function() {
        this.courses_to_add = ''
        this.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyam/tanfolyamok_search_220113', {
          token: this.token,
          nkh_course_type_id: this.nkh_course_type_id,
          tanfolyam_search_text: this.tanfolyam_search_text,
          contract_id: this.contract_id
        }).then((response) => {
          this.preloader = false
          this.courses_to_add = response.data

        }, (error) => {
          this.error_text = error.data
        })
      },
      searchCourseLessons: async function(course_id) {
        await this.gettoken()
        this.$http.post('/tanfolyam/lessons', {
          token: this.token,
          course_id: course_id
        }).then((response) => {
          this.course_details = true
          this.course_lessons = response.data['lessons']
        }, (error) => {
          this.error_text = error.data
        })
      },
      courseDetails: async function(course_id) {
        await this.gettoken()
        this.$http.post('/tanfolyam/lessons', {
          token: this.token,
          course_id: course_id
        }).then((response) => {
          this.course_details_dialog = true
          this.course_lessons = response.data['lessons']
        }, (error) => {
          this.error_text = error.data
        })
      },
      addStudentCourse: async function() {
        this.preloader = true
        this.preg_preloader = true
        this.loading_dialog = true
        this.invoice_id = null
        this.contract_course_id = null
        await this.gettoken()
        this.$http.post('/tanfolyam/tanfolyam_add_student_230402', {
          token: this.token,
          course_id: this.selected_course,
          //customer_id: this.customer_id,
          contract_id: this.contract_id,
          school_id: this.selected_course_school_id,
          payment_method: this.payment_method
        }).then((response) => {
          this.preloader = false
          this.preg_preloader = false
          this.response_text = response.data['message']
          this.roster_status = response.data['roster']
          this.prereg_result = response.data['result']
          this.invoice_id = response.data['invoice_id']
          this.invoice_number = response.data['iv_number']
          this.contract_course_id = response.data['course_id']
          this.iv_driving_school = response.data['school_id']
          this.public_url = response.data['public_url']
          if (response.data['result'] == 'error') {
            this.snackbar_color = 'error'
            this.snackbar_close = ''
          } else {
            this.snackbar_color = null
            this.snackbar_close = 'pink'
          }
          this.lessonHeadcountAdd()
          this.getCourseDetails();
          EventBus.$emit('refreshPayments');
          this.preg_dialog = false
          //this.response_snackbar = true
        }, (error) => {
          this.error_text = error.data
        })
      },
      delStudentCourse: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyam/tanfolyam_del_student', {
          token: this.token,
          course_id: this.course_del_id,
          courses_data_id: this.courses_data_del_id,
          course_student_id: this.course_student_del_id,
          //customer_id: this.customer_id,
          contract_id: this.contract_id
        }).then((response) => {
          this.preloader = false
          this.response_text = response.data['message']
          this.roster_status = response.data['roster']
          if (response.data['result'] == 'error') {
            this.snackbar_color = 'error'
            this.snackbar_close = ''
          } else {
            this.snackbar_color = null
            this.snackbar_close = 'pink'
          }
          this.lessonHeadcountDel()
          this.getCourseDetails();
          this.response_snackbar = true
        }, (error) => {
          this.error_text = error.data
        })
      },
      lessonHeadcountDel: async function() {
        this.headcount_update = false
        this.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyam/lessons_headcount', {
          token: this.token,
          course_del_id: this.course_del_id,
        }).then((response) => {
          this.headcount_update = response.data
          this.preloader = false
          this.course_del_id = null

        }, (error) => {
          this.error_text = error.data
        })
      },
      lessonHeadcountAdd: async function() {
        this.headcount_update = false
        this.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyam/lessons_headcount', {
          token: this.token,
          course_id_selected: this.selected_course,
        }).then((response) => {
          this.headcount_update = response.data
          this.preloader = false
          this.selected_course = null

        }, (error) => {
          this.error_text = error.data
        })
      },
      downloadContract: async function(course_id) {
        if (this.contract_course_id) {
          course_id = this.contract_course_id
        }
        this.preloader = true
        await this.gettoken()
        this.$http.post('/adatok/szerzodes', {
          token: this.token,
          contract_id: this.contract_id,
          //customer_id: this.customer_id,
          course_id: course_id,
        }, {responseType: 'blob'}).then((response) => {
          this.preloader = false
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.customer_name+'_szerzodes_'+this.soap_course_type_code+'.pdf');
          document.body.appendChild(link);
          link.click();
        }, (error) => {
          this.error_text = error.data
        })
      },
      downloadInvoice: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('tanfolyam/download_invoice', {
          token: this.token,
          school_id: this.iv_driving_school,
          invoice_id: this.invoice_id
        }, {responseType: 'blob'}).then((response) => {
          this.preloader = false
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.invoice_number+'.pdf');
          document.body.appendChild(link);
          link.click();
        }, (error) => {
          this.error_text = error.data
        })
      },
    },
    mounted() {
      if (this.contract_id) {
        this.getCourseDetails()
      }
      //this.getCourseDetails()
      this.getOffices()
    },
    watch: {
      contract_id: function (value) {
        if (value) {
          this.getCourseDetails()
        }
      },
      tanfolyam_search_text() {
        this.searchCourses()
      }
    },
    computed: {
        ...mapFields([
          'ids.customer_id',
          'ids.contract_id',
          'ids.nkh_course_type_id',
          'ids.driving_school',
          'user_datas.contracts',
          'ids.customer_name',
          'actions.preloader',
          'actions.message_dialog',
        ]),
      },
  }
</script>

<style lang="css">
</style>
